import { useEffect, useState } from 'react';
import { getAccount } from '@/api';
import { LmtWidgetType } from '@/domain/live';

type SirQueue = ((...args: unknown[]) => void) & {
  q?: unknown[][];
  l?: number;
  o?: Record<string, unknown>;
};

function loadBetradarScript(clientId: string, language: string, onLoad: () => void) {
  if (window.SIR) {
    onLoad();
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://widgets.sir-sportradar.com/${clientId}/widgetloader`;
  script.setAttribute('n', 'SIR');
  script.onload = onLoad;

  if (!window.SIR) {
    const sir = function (...args: unknown[]) {
      (sir.q = sir.q || []).push(args);
    } as SirQueue;
    sir.l = Date.now();
    // theme: false — do not fetch Sportradar hosted CSS; local sir-widgettheme.css styles .srt-*.
    sir.o = { language, debug: false, silent: true, theme: false };
    window.SIR = sir;
  }

  document.head.appendChild(script);
}

/** Loads the Betradar SIR widgetloader when the account is configured for Betradar LMT. */
export function useLoadLmtScript(language = 'en') {
  const [isLoaded, setIsLoaded] = useState(Boolean(window.SIR));

  useEffect(() => {
    const account = getAccount();
    const trackingType = account?.LiveMatchTrackingType ?? LmtWidgetType.None;
    const trackingKey = account?.LiveMatchTrackingKey?.trim();

    if (trackingType !== LmtWidgetType.Betradar || !trackingKey) {
      return;
    }

    if (window.SIR) {
      setIsLoaded(true);
      return;
    }

    loadBetradarScript(trackingKey, language, () => setIsLoaded(true));
  }, [language]);

  return isLoaded;
}
